export default __webpack_public_path__ + "images/0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca.png";